module.exports = __webpack_public_path__ + "static/media/dashboard_icon_menu.d831def6.svg";